import axios from "@/helpers/axios";
const commonURL = "/payments";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async registerCard({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "post",
          url: `${commonURL}/biz/register-card`,
          data: payload,
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async myCard({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "GET",
          url: `${commonURL}/biz/my-card`,
        });
        if (result.data.success) {
          return result.data;
        } else {
          throw Error("Error on actions");
        }
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async getParentsBillings({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "GET",
          url: `${commonURL}/biz-member/manager-card`,
        });
        if (result.data.success) {
          return result.data;
        } else {
          throw Error("Error on actions");
        }
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async deleteCard({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios({
          method: "POST",
          url: `${commonURL}/biz/delete-card`,
          data: {
            billingId: payload,
          },
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  },
};
